import { StyleSheet, View } from 'react-native';
import { useScale } from '@/hooks/useScale';

type ChapterMarker = {
  position: number; // 0..1
  title: string;
};

type Props = {
  progress: number; // 0..1
  markers: ChapterMarker[];
};

export default function GuidedProgressBar({ progress, markers }: Props) {
  const scale = useScale();
  const barHeight = 8 * scale;
  const markerWidth = 2 * scale;

  return (
    <View style={[styles.container, { height: barHeight }]}>
      {/* Background track */}
      <View style={[styles.track, { height: barHeight, borderRadius: barHeight / 2 }]}>
        {/* Filled portion */}
        <View
          style={[
            styles.fill,
            {
              width: `${Math.min(Math.max(progress, 0), 1) * 100}%`,
              height: barHeight,
              borderRadius: barHeight / 2,
            },
          ]}
        />
      </View>

      {/* Chapter boundary markers */}
      {markers.map((marker, idx) => (
        <View
          key={idx}
          style={[
            styles.marker,
            {
              left: `${marker.position * 100}%`,
              width: markerWidth,
              height: barHeight + 4 * scale,
              top: -2 * scale,
            },
          ]}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
  },
  track: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    overflow: 'hidden',
  },
  fill: {
    backgroundColor: '#fff',
  },
  marker: {
    position: 'absolute',
    backgroundColor: 'rgba(255,255,255,0.5)',
  },
});
